// extracted by mini-css-extract-plugin
module.exports = {"page":"Main_page__2TMIs"};